module.exports = __webpack_public_path__ + "static/media/logo-dark-full.3cbb21d7.svg";